import { useEffect, useState } from "react";
import type { PublishedSnapshot } from "@cs2/contracts/domain";

const seenRevisionKey = "cs2-quickview-seen-revision";

/**
 * Merkt sich die zuletzt gesehene Revision, damit ein neu veröffentlichter
 * Stand vor dem Match auffällt, statt unbemerkt vorbeizuziehen.
 *
 * Der erste Besuch ist der heikle Fall: ohne Vergleichswert würde jeder
 * bestehende Snapshot fälschlich als „neu" gemeldet. Deshalb wird er still
 * gemerkt statt angezeigt.
 */
export function useRevisionBanner(snapshot: PublishedSnapshot | null) {
  const [seenRevision, setSeenRevision] = useState<number | null>(() => {
    const stored = localStorage.getItem(seenRevisionKey);
    return stored === null ? null : Number(stored);
  });

  useEffect(() => {
    if (!snapshot || seenRevision !== null) return;
    localStorage.setItem(seenRevisionKey, String(snapshot.revision));
    setSeenRevision(snapshot.revision);
  }, [snapshot, seenRevision]);

  return {
    /** Wahr, sobald eine neuere Revision vorliegt als die zuletzt gesehene. */
    hasUnseenRevision:
      snapshot !== null &&
      seenRevision !== null &&
      snapshot.revision > seenRevision,
    seenRevision,
    // Als Pfeilfunktion, damit sie sich direkt als `onClick` übergeben lässt,
    // ohne `this` mitzunehmen.
    acknowledge: () => {
      if (!snapshot) return;
      localStorage.setItem(seenRevisionKey, String(snapshot.revision));
      setSeenRevision(snapshot.revision);
    },
  };
}
